var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controller-frame"},[_c('header',[_c('h1',{domProps:{"textContent":_vm._s(_vm.title)}})]),_vm._t("nav"),_c('scrollview',{staticClass:"body"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }